
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import JSConfetti from 'js-confetti';

export const timeRanges = {
  '7d': { label: 'Last 7 Days', days: 7 },
  '30d': { label: 'Last 30 Days', days: 30 },
  '90d': { label: 'Last 90 Days', days: 90 },
  'all': { label: 'All Time', days: 0 }
};

export const useDashboardState = () => {
  const [timeRange, setTimeRange] = useState("30d");
  const [activeTab, setActiveTab] = useState<string>("stats");
  const [isRefreshing, setIsRefreshing] = useState(false);
  const location = useLocation();

  // Handle URL params for active tab
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    if (tabParam === 'create') {
      setActiveTab('create');
    } else {
      setActiveTab('stats');
    }
  }, [location]);

  // Handle confetti animation on login
  useEffect(() => {
    const isFromLogin = location.state && location.state.fromLogin === true;
    
    if (isFromLogin) {
      const jsConfetti = new JSConfetti();
      jsConfetti.addConfetti({
        emojis: ['🎵', '⚡️', '💥', '✨', '🎤', '🔊'],
        emojiSize: 30,
      });
      
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location]);

  const handlePromoteTrack = () => {
    if (activeTab === 'create') {
      setActiveTab('stats');
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('tab');
      window.history.pushState({}, '', newUrl.toString());
    } else {
      setActiveTab('create');
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('tab', 'create');
      window.history.pushState({}, '', newUrl.toString());
    }
  };

  return {
    timeRange,
    setTimeRange,
    activeTab,
    setActiveTab,
    isRefreshing,
    setIsRefreshing,
    handlePromoteTrack,
    timeRanges
  };
};
